// pages/resources/Stories.jsx
export default function Stories() {
  const stories = [
    {
      company: "TechStart Inc.",
      industry: "SaaS",
      result: "300% ROI",
      description: "How TechStart scaled their B2B campaigns and tripled their return on ad spend",
      metrics: { conversions: "+250%", cpa: "-45%", reach: "2M+" },
      logo: "T"
    },
    {
      company: "Fashion Hub",
      industry: "E-commerce",
      result: "5x Revenue",
      description: "Fashion Hub's journey from startup to market leader through strategic advertising",
      metrics: { conversions: "+420%", cpa: "-52%", reach: "5M+" },
      logo: "F"
    },
    {
      company: "EduLearn Platform",
      industry: "Education",
      result: "200% Growth",
      description: "Doubling student enrollment with targeted multi-channel campaigns",
      metrics: { conversions: "+180%", cpa: "-38%", reach: "1.5M+" },
      logo: "E"
    },
    {
      company: "HealthFit App",
      industry: "Health & Fitness",
      result: "400% Downloads",
      description: "Mobile app explosion: From 10K to 50K downloads in 3 months",
      metrics: { conversions: "+380%", cpa: "-41%", reach: "3.2M+" },
      logo: "H"
    },
    {
      company: "Green Energy Co.",
      industry: "Clean Tech",
      result: "150% Leads",
      description: "Sustainable growth for a sustainable business through smart advertising",
      metrics: { conversions: "+160%", cpa: "-35%", reach: "800K+" },
      logo: "G"
    },
    {
      company: "FoodDash Delivery",
      industry: "Food Tech",
      result: "10x Orders",
      description: "Scaling food delivery in competitive markets with performance campaigns",
      metrics: { conversions: "+890%", cpa: "-58%", reach: "4M+" },
      logo: "F"
    }
  ];

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-4">
            Customer Success Stories
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Real results from real businesses that transformed their growth with Adsurg
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {stories.map((story, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-gray-900 to-black border border-white/10 rounded-2xl p-8 hover:border-[#00809D]/50 transition-all duration-300 hover:shadow-2xl hover:shadow-[#00809D]/20"
            >
              <div className="flex items-start gap-6 mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-[#00809D] to-[#00a0c4] rounded-2xl flex items-center justify-center text-white font-bold text-2xl flex-shrink-0 shadow-lg shadow-[#00809D]/50">
                  {story.logo}
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-white mb-1 group-hover:text-[#00809D] transition-colors">
                    {story.company}
                  </h3>
                  <span className="text-gray-400 text-sm">{story.industry}</span>
                </div>
                <div className="text-right">
                  <div className="text-3xl font-bold text-[#00809D] mb-1">
                    {story.result}
                  </div>
                </div>
              </div>

              <p className="text-gray-300 mb-6 text-lg leading-relaxed">
                {story.description}
              </p>

              <div className="grid grid-cols-3 gap-4 mb-6">
                <div className="bg-black/50 border border-white/10 rounded-xl p-4 text-center">
                  <div className="text-[#00809D] font-bold text-xl mb-1">{story.metrics.conversions}</div>
                  <div className="text-gray-400 text-xs">Conversions</div>
                </div>
                <div className="bg-black/50 border border-white/10 rounded-xl p-4 text-center">
                  <div className="text-[#00809D] font-bold text-xl mb-1">{story.metrics.cpa}</div>
                  <div className="text-gray-400 text-xs">CPA</div>
                </div>
                <div className="bg-black/50 border border-white/10 rounded-xl p-4 text-center">
                  <div className="text-[#00809D] font-bold text-xl mb-1">{story.metrics.reach}</div>
                  <div className="text-gray-400 text-xs">Reach</div>
                </div>
              </div>

              <button className="w-full bg-gradient-to-r from-[#00809D] to-[#00a0c4] text-white px-6 py-3 rounded-xl font-semibold hover:scale-105 transition-all shadow-lg shadow-[#00809D]/50">
                Read Full Story →
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
